import queryString from 'query-string';


const NEW_DOCUMENT_QUERY_PARAM_KEY = 'isNewDocument';

/**
 * Parse the new document queryString from URL
 * @returns {boolean} new document queryString
 */
function getIsNewDocumentFromWindowLocation() {
    return (
        queryString.parse(window.location.search)[NEW_DOCUMENT_QUERY_PARAM_KEY]
        === 'true'
    );
}

export default getIsNewDocumentFromWindowLocation;
export { NEW_DOCUMENT_QUERY_PARAM_KEY };
